import React, { useContext } from 'react';
import 'twin.macro';
import { AppContext, PreferenceContext } from '../context';
import { useNavigate } from 'react-router-dom';
import { Switch } from '../form';
import { MenuContent, MenuHeader } from './';
import { ThemeSwitcher } from '../theme';
import { MediaFilter } from '../filter';
import { CommentsSorting } from '../comments';
import { gaEvent } from 'services/ga';
import {
  CheckIcon,
  CommentsNextToIcon,
  CommentsUnderIcon,
  FilterIcon,
  LayoutGridIcon,
  LayoutListIcon,
  MoonIcon,
  NsfwIcon,
  PinnedIcon,
  PlayIcon,
  PlayNextIcon,
  SideBarLeftIcon,
  SideBarRightIcon,
  SortIconDown,
  SunIcon,
  TimesIcon,
  UnPinnedIcon,
} from 'icons';
import { DropDown, DropDownItem } from '../dropdown';
import { SettingsDividerTitle, SettingsItem } from '../settings';

export const SwitchNSFW = ({ ...props }) => <Switch {...props} />;
export const SwitchSidebarPosition = ({ ...props }) => <Switch {...props} />;
export const SwitchCommentsPosition = ({ ...props }) => <Switch {...props} />;
export const SwitchHighlightedItems = ({ ...props }) => <Switch {...props} />;
export const SwitchUpNext = ({ ...props }) => <Switch {...props} />;
export const SwitchStickyVideoMobile = ({ ...props }) => <Switch {...props} />;

export const SettingsMenu = () => {
  const { windowSize } = useContext(AppContext);
  const {
    preference: {
      nsfwActive,
      highlightedItems,
      landscape,
      sideBarLeftSide,
      upNextActive,
      stickyVideoMobile,
      commentsUnderVideo,
      theme,
    },
    setPreference,
  } = useContext(PreferenceContext);
  const navigate = useNavigate();

  return (
    <>
      <MenuHeader title='instellingen' />
      <MenuContent>
        <SettingsDividerTitle title='Algemeen' />
        <SettingsItem
          title='Highlight bekeken items'
          description='Bekeken items krijgen een vinkje.'
          iconType={highlightedItems ? CheckIcon : TimesIcon}
        >
          <SwitchHighlightedItems
            isChecked={highlightedItems}
            onClick={() => {
              setPreference({ highlightedItems: !highlightedItems });
              gaEvent('dmp_settings_change', `highlight_${!highlightedItems}`);
            }}
          />
        </SettingsItem>
        <SettingsItem
          title='Automatisch afspelen'
          description='De volgende video speelt automatisch af.'
          iconType={upNextActive ? PlayNextIcon : PlayIcon}
        >
          <SwitchUpNext
            isChecked={upNextActive}
            onClick={() => {
              setPreference({ upNextActive: !upNextActive });
              gaEvent('dmp_settings_change', `upnext_${!upNextActive}`);
            }}
          />
        </SettingsItem>
        {['MOBILE'].includes(windowSize.adBreakPoint) && (
          <>
            <SettingsItem
              title='Sticky video op mobiel'
              description='Video blijft in beeld bij het scrollen op een portrait scherm.'
              iconType={stickyVideoMobile ? PinnedIcon : UnPinnedIcon}
            >
              <SwitchStickyVideoMobile
                isChecked={stickyVideoMobile}
                onClick={() => {
                  setPreference({ stickyVideoMobile: !stickyVideoMobile });
                  gaEvent('dmp_settings_change', `sticky_video_mobile_${!stickyVideoMobile}`);
                }}
              />
            </SettingsItem>
          </>
        )}
        <SettingsItem
          title='NSFW'
          description='Laat dumps zien die niet geschikt zijn voor de werkvloer.'
          iconType={NsfwIcon}
          fillcolor={nsfwActive ? '#66cc22' : 'currentColor'}
        >
          <SwitchNSFW
            isChecked={nsfwActive}
            onClick={() => {
              setPreference({ nsfwActive: !nsfwActive });
              gaEvent('dmp_settings_change', `nsfw_${!nsfwActive}`);
              navigate(0);
            }}
          />
        </SettingsItem>
        {['DESKTOP'].includes(windowSize.adBreakPoint) && (
          <>
            <SettingsItem
              title='Zijbalk links'
              description='Als je liever de zijbalk en de comments aan de linkerkant wilt zien.'
              iconType={sideBarLeftSide ? SideBarLeftIcon : SideBarRightIcon}
            >
              <SwitchSidebarPosition
                isChecked={sideBarLeftSide}
                onClick={() => {
                  setPreference({ sideBarLeftSide: !sideBarLeftSide });
                  gaEvent('dmp_settings_change', `set_sidebar_${!sideBarLeftSide}`);
                }}
              />
            </SettingsItem>
          </>
        )}
        {['DESKTOP'].includes(windowSize.adBreakPoint) && (
          <>
            <SettingsItem
              title='Reaguursels onder item'
              description='Plemp de reaguursels onder de video.'
              iconType={commentsUnderVideo ? CommentsUnderIcon : CommentsNextToIcon}
            >
              <SwitchCommentsPosition
                isChecked={commentsUnderVideo}
                onClick={() => {
                  setPreference({ commentsUnderVideo: !commentsUnderVideo });
                  gaEvent('dmp_settings_change', `set_comments_under_${!commentsUnderVideo}`);
                }}
              />
            </SettingsItem>
          </>
        )}
        <SettingsItem
          title='Lijstweergave'
          description='Bepaal hier of je kleine of grote afbeeldingen wilt zien in de lijst.'
          iconType={landscape ? LayoutGridIcon : LayoutListIcon}
        >
          <DropDown label={landscape ? 'Groot' : 'Klein'} isSelect isRight>
            <DropDownItem
              label='Klein'
              selectedValue={!landscape}
              onClick={() => {
                setPreference({ landscape: !landscape });
                gaEvent('dmp_settings_change', 'list_view_list');
              }}
            />
            <DropDownItem
              label='Groot'
              selectedValue={landscape}
              onClick={() => {
                setPreference({ landscape: !landscape });
                gaEvent('dmp_settings_change', 'list_view_card');
              }}
            />
          </DropDown>
        </SettingsItem>
        <SettingsItem
          title='Thema'
          description='Selecteer hier de kleur voor je Dumpert website.'
          iconType={theme === 'light' ? SunIcon : MoonIcon}
        >
          <ThemeSwitcher isRight />
        </SettingsItem>
        <SettingsDividerTitle title='Media' />
        <SettingsItem
          title='Filter'
          description={"Bepaal of je enkel video's of plaatjes wilt zien."}
          iconType={FilterIcon}
        >
          <MediaFilter isRight />
        </SettingsItem>
        <SettingsDividerTitle title='Reaguursels' />
        <SettingsItem
          title='Sorteren'
          description={'Sorteer de reaguursels in de lijst.'}
          iconType={SortIconDown}
        >
          <CommentsSorting menuRight />
        </SettingsItem>
      </MenuContent>
    </>
  );
};
